import { Action, Reducer } from "redux";
import { SupplierCategoryState, SupplierCategoryTypes, SupplierCategoryActionTypes } from "./supplierCategoryTypes";

export const INITIAL_STATE: SupplierCategoryState = {
	supplierCategory: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const supplierCategoryReducer: Reducer<SupplierCategoryState> = (
	state: SupplierCategoryState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as SupplierCategoryActionTypes;
	switch (actionTypes.type) {
		case SupplierCategoryTypes.GET_SUPPLIER_CATEGORY:
			return {
				...state,
				supplierCategory: { ...state.supplierCategory, isLoading: true },
			};
		case SupplierCategoryTypes.SAVE_SUPPLIER_CATEGORY:
			return {
				...state,
				supplierCategory: {
					...state.supplierCategory,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case SupplierCategoryTypes.RESET_REDUCER_SUPPLIER_CATEGORY:
			return {
				...state,
				supplierCategory: INITIAL_STATE.supplierCategory,
			};
		default:
			return state;
	}
};

export default supplierCategoryReducer;
